import { useState, useCallback } from 'react';

function safeGetItem<T>(key: string, initialValue: T): T {
  const storedValue = sessionStorage.getItem(key);
  try {
    return storedValue ? JSON.parse(storedValue) : initialValue;
  } catch {
    return initialValue;
  }
}

function safeSetItem<T>(key: string, value: T): void {
  sessionStorage.setItem(key, JSON.stringify(value));
}

export function useSessionStorage<T>(key: string, initialValue: T) {
  const [value, setValue] = useState<T>(() => safeGetItem(key, initialValue));

  const storeValue = useCallback(
    (newValue: T) => {
      safeSetItem(key, newValue);
      setValue(newValue);
    },
    [key],
  );

  return [value, storeValue] as const;
}
